if (!customElements.get('slider-products-block')) {
  class SliderProductsBlock extends HTMLElement {
    constructor() {
      super();
      this.state = { isInitialized: false };

      this.elements = {
        swiperContainer: this,
        nextButton: this.querySelector('.swiper-button-next'),
        prevButton: this.querySelector('.swiper-button-prev'),
      };

      this.swiperInstance = null;
    }

    connectedCallback() {
      this.init();
    }

    disconnectedCallback() {
      this.destroy();
    }

    init() {
      if (this.state.isInitialized) return;

      const slides = this.querySelectorAll('.swiper-slide');
      if (!slides || slides.length < 2) return;

      this.initSwiper();
      this.state.isInitialized = true;
    }

    initSwiper() {
      this.swiperInstance = new Swiper(this, {
        loop: false,
        centeredSlides: false,
        slidesPerView: 'auto',
        navigation: {
          nextEl: this.elements.nextButton,
          prevEl: this.elements.prevButton,
        },
        keyboard: {
          enabled: true,
          onlyInViewport: true,
        },
        a11y: {
          enabled: true,
          prevSlideMessage: window.accessibilityLabels.slider.previousSlide,
          nextSlideMessage: window.accessibilityLabels.slider.nextSlide,
          firstSlideMessage: window.accessibilityLabels.slider.firstSlide,
          lastSlideMessage: window.accessibilityLabels.slider.lastSlide,
        }
      });
    }

    destroy() {
      if (this.swiperInstance) {
        this.swiperInstance.destroy(true, true);
        this.swiperInstance = null;
      }
      this.state.isInitialized = false;
    }
  }

  customElements.define('slider-products-block', SliderProductsBlock);
}
